import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { brandInfo } from '@/mocks/brand';

function BrandIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
              品牌介绍
            </span>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-5 leading-tight">
              {brandInfo.name} — {brandInfo.slogan}
            </h1>
            <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
              {brandInfo.description}
            </p>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
              自{Number(brandInfo.founded)}年成立以来，乐鱼始终坚持以技术创新为驱动，以用户需求为核心，不断优化产品功能与服务体验。平台拥有专业的技术研发团队和客户服务团队，致力于为广大用户打造一个安全、可靠、流畅的在线平台。
            </p>
          </div>
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20professional%20office%20building%20exterior%20with%20warm%20golden%20hour%20lighting%2C%20glass%20facade%2C%20corporate%20headquarters%20style%2C%20clean%20minimalist%20architecture%2C%20trustworthy%20and%20premium%20atmosphere%2C%20warm%20amber%20tones&width=800&height=600&seq=about-brand-01&orientation=landscape"
              alt="乐鱼官网品牌形象"
              className="w-full h-auto rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function ValuesSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
            核心价值
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            我们的核心价值观
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            乐鱼始终坚持的核心价值理念，引领平台持续发展
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {brandInfo.values.map((value, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-2xl p-6 md:p-8 flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-100 flex items-center justify-center mb-5">
                <i className={`${value.icon} text-2xl md:text-3xl text-accent-500`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-3">
                {value.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function AchievementsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            平台数据
          </h2>
          <p className="text-background-50/70 text-sm md:text-base max-w-xl mx-auto">
            数年的稳健运营，铸就值得信赖的品牌
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {brandInfo.achievements.map((achievement, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-2">
                {achievement.number}
              </div>
              <div className="text-sm md:text-base text-background-50/80 font-medium">
                {achievement.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系乐鱼官方
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            如有任何问题或建议，欢迎通过以下方式联系我们
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col items-center text-center">
            <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-5">
              <i className="ri-mail-line text-2xl text-primary-500"></i>
            </div>
            <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">电子邮箱</h3>
            <p className="text-sm text-foreground-600">{brandInfo.contact.email}</p>
          </div>
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col items-center text-center">
            <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mb-5">
              <i className="ri-phone-line text-2xl text-accent-500"></i>
            </div>
            <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">客服热线</h3>
            <p className="text-sm text-foreground-600">{brandInfo.contact.phone}</p>
          </div>
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col items-center text-center">
            <div className="w-14 h-14 rounded-2xl bg-secondary-100 flex items-center justify-center mb-5">
              <i className="ri-time-line text-2xl text-secondary-500"></i>
            </div>
            <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">工作时间</h3>
            <p className="text-sm text-foreground-600">{brandInfo.contact.workingHours}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: brandInfo.faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
              常见问题
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              常见问题解答
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              我们整理了用户最常咨询的问题，希望能帮助到您
            </p>
          </div>
          <div className="flex flex-col gap-4">
            {brandInfo.faqs.map((faq, index) => (
              <details key={index} className="group bg-background-50 rounded-2xl p-5 md:p-6 cursor-pointer">
                <summary className="flex items-center justify-between gap-4 list-none">
                  <h4 className="font-heading text-base font-bold text-foreground-950 pr-8">
                    {faq.question}
                  </h4>
                  <i className="ri-add-line text-xl text-foreground-400 group-open:hidden flex-shrink-0"></i>
                  <i className="ri-subtract-line text-xl text-primary-500 hidden group-open:block flex-shrink-0"></i>
                </summary>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed pt-4 border-t border-background-200">
                  {faq.answer}
                </p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 乐鱼官网',
          description: '了解乐鱼官网品牌介绍、核心价值观、联系方式及常见问题。乐鱼官网 - 官方正版入口，安全可信赖。',
          url: 'https://www.leyu.com/about',
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="bg-background-100">
            <div className="max-w-7xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
            </div>
          </div>
          <BrandIntro />
          <ValuesSection />
          <AchievementsSection />
          <ContactSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}